import { useEffect } from 'react';

import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';

import { GX_TOKEN_STORAGE_ATTRIBUTE_NAME } from '@/constants/constants';
import { logout } from '@/slices/authSlice';

export const useLogoutListener = (): void => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const handleStorageChange = (event: StorageEvent): void => {
      if (event.key === GX_TOKEN_STORAGE_ATTRIBUTE_NAME && !event.newValue) {
        dispatch(logout());
        navigate('/login');
      }
    };

    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, [dispatch, navigate]);
};
